import { InjectionToken } from '@angular/core';
import { TrackingConfig } from './tracking.interface';

export const TRACKING_CONFIG = new InjectionToken<TrackingConfig>(
  'TrackingConfig',
);



// WEBPACK FOOTER //
// ./src/app/@shared/tracking/tracking.config.ts